import { screen } from '@testing-library/preact';
import { VNode } from 'preact';
import { ListItemRendererContext, SelectionMode } from '../../UNSAFE_Collection';
import { ActionDetail } from '../../UNSAFE_BaseButton';
import { Avatar } from '../../UNSAFE_Avatar';
import { Button } from '../../UNSAFE_Button';
import { Text } from '../../UNSAFE_Text';
import { View } from '../../UNSAFE_View';
import { Employee } from '../__dev__/BaseCardViewData';

export type GenericCardGridProps = {
  data: Employee[];
  delay?: number;
};

export type ActionCardGridProps = GenericCardGridProps & {
  handleAction?: (details: ActionDetail) => void;
  showButton?: boolean; // for testing invalid focusBehavior
};

export type SelectionCardGridProps = GenericCardGridProps & {
  selectionMode?: SelectionMode;
  selectedKeys?: Set<Employee['id']>;
};

export type TestComponentsProps = {
  GenericCardGrid: (props: GenericCardGridProps) => VNode;
  ActionCardGrid: (props: ActionCardGridProps) => VNode;
  SelectionCardGrid: (props: SelectionCardGridProps) => VNode;
} & Record<string, (props: any) => VNode>;

export const CardContent = ({
  context,
  showButton
}: {
  context: ListItemRendererContext<Employee['id'], Employee>;
  showButton?: boolean;
}) => {
  return (
    <View padding="4x">
      <Avatar initials={context.data.initials} size="xl" />
      <div style="margin-top: 15px;">
        <Text variant="primary" size="md" lineClamp={1}>
          {context.data.name}
        </Text>
      </div>
      <Text variant="secondary" size="md" lineClamp={1}>
        {context.data.title}
      </Text>
      {showButton && (
        <div style="margin-top: 5px;">
          <div style="margin-right: 5px; display: inline-block;">
            <Button variant="outlined" size="md" label="A"></Button>
          </div>
          <div style="display: inline-block;">
            <Button variant="outlined" size="md" label="B"></Button>
          </div>
        </div>
      )}
      {context.selector && (
        <div style="position: relative; left: -13px">{context.selector?.()}</div>
      )}
    </View>
  );
};

export const populateData = (count: number, isNumberKey?: boolean) =>
  [...Array(count)].map(
    (_, i) =>
      ({
        id: isNumberKey ? i : `${i}`,
        name: `Employee ${i}`,
        title: `Employee title ${i}`,
        initials: `E${i}`
      }) as Employee
  );

export const getRoot = async () => {
  return screen.findByRole('grid');
};

export const getItems = async (role = 'row') => {
  return screen.findAllByRole(role);
};
